import LivechatClient from '@rocket.chat/sdk/lib/clients/Livechat';
import Axios from 'axios';
const serverUrl = "https://my.qatarcool.com";
const adminUrl = `${serverUrl}/admin`;
export const tenantCode = "QCC";
const host = `${ serverUrl }/livechat-admin`;
const getHttpOrHttps = (useSSl)=>{
  if(useSSl == true){
    return 'https';
  }
  return 'http';
}
const getWsOrWss = (useSSL)=>{
  if(useSSL == true){
    return 'wss';
  }
  return 'ws';
}
const useSsl = host && host.match(/^https:/) !== null;
const socketHostUrl = serverUrl.replace(getHttpOrHttps(useSsl), getWsOrWss(useSsl));
const webSocketUrl = `${socketHostUrl}/socket/`;
export const Livechat = new LivechatClient({ host, protocol: 'ddp', useSsl });

export class CustumApiClass  {
    async getWidgetSettings() {
      let headers = {'accessToken': this.getAccessToken()}
        return (await Axios.get(`${adminUrl}/admin-service?query={
            allSettings: getWidgetSettings(input:{tenantCode: "${tenantCode}"}) {
              primaryColor,
              secondaryColor,
              tertiaryColor,
              quaternaryColor,
              quinaryColor,
              chatBotTitle,
              businessHour,
              extraAddributes,
              initialMessages
            }
          }`,
          {headers}
          )).data;
    }

    connectToSocket(){
      const client = new WebSocket(webSocketUrl);
      return new Promise((resolve, reject) => {
        client.addEventListener('open', e => {
          setInterval(() => {
            client.send(JSON.stringify({type: 'PING'}))
          }, 10000);
          resolve(client);
        });
      })
    }
    getAccessToken(){
      let bearer = JSON.parse(localStorage.getItem('bearer') != null || localStorage.getItem('bearer') != undefined ? localStorage.getItem('bearer') : localStorage.getItem('authbearer'));
      return bearer.acessToken ? bearer.acessToken : bearer.access_token;
    }
    getHttpOrHttps(useSSl){
      if(useSSl == true){
        return 'https';
      }
      return 'http';
    }
    getWsOrWss(useSSL){
      if(useSSL == true){
        return 'wss';
      }
      return 'ws';
    }
}